<script setup lang="ts">
import { StudentCourseStatus, StudentExamStatus, type StudentCourseLockout } from '@/types/FlightSchoolStudent';
import StatusBadge from './StatusBadge.vue';
import type { FlightSchoolStatus } from '@/types/FlightSchoolStatus';

defineProps<{
    status: StudentCourseStatus | FlightSchoolStatus | StudentExamStatus,
    lockout?: StudentCourseLockout,
}>();
</script>

<template>
    <div class="row">
        <StatusBadge
            :status="status"
        />
    </div>
    <div
        v-if="lockout"
        class="row q-mt-sm"
    >
        <StatusBadge
            :status="StudentCourseStatus.locked"
            :tooltip="lockout.reason"
        />
    </div>
</template>
